import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import backimg from "../img/back.jpg";
import bb from "../img/back2.png";
import ZEET from "../img/ZEET.jpg";
import Admin from "../img/Admin.jpg";
import M from "../img/M.jpg";
import GitHubIcon from "@mui/icons-material/GitHub";
import EastIcon from "@mui/icons-material/East";
import { Mobile, Landscape } from "../Response";

const Projects = () => {
  const back = useSelector((state) => state.switch.back);
  return (
    <Container className="mol">
      <Wrap>
        <Title back={back}>Some of my Applications</Title>
        <TopCon>
          <Item back={back}>
            <ImgCon>
              <ItemImg src={ZEET} />
            </ImgCon>
            <DESC back={back}>
              <TitleAndLink>
                <TitleLink back={back}>
                  ZEET SHOP &nbsp;&nbsp;&nbsp;&nbsp;Full Stack Web Application
                </TitleLink>
                <DeployLink>
                  <VCon back={back}>
                    <Vist back={back}>Click here &nbsp;&nbsp;&nbsp;</Vist>
                    <EastIcon className="Visit" />
                  </VCon>
                  <WebLink
                    href="https://zeetshopeco.netlify.app"
                    target="_blank"
                    back={back}
                  >
                    &nbsp;&nbsp;&nbsp;ZEETSHOP.COM
                  </WebLink>
                </DeployLink>
              </TitleAndLink>
              <IconLink>
                <GitIconLink
                  href="https://github.com/Mariwan-A-MOH/ZEET-E-C-FULL-STACK-MERN-APP"
                  target="_blank"
                  back={back}
                >
                  <GitHubIcon className="iicon" type="type" />
                </GitIconLink>
              </IconLink>
            </DESC>
          </Item>
        </TopCon>
        <BottomCon>
          <LefttCon>
            <Item back={back}>
              <ImgCon>
                <ItemImg src={M} />
              </ImgCon>
              <DESC back={back}>
                <TitleAndLink m="m">
                  <TitleLink back={back}>
                    M FILM &nbsp;&nbsp;&nbsp;&nbsp;Full Stack Web Application
                  </TitleLink>
                  <DeployLink>
                    <VCon back={back}>
                      <Vist back={back}>Click here &nbsp;&nbsp;&nbsp;</Vist>
                      <EastIcon className="Visit" />
                    </VCon>
                    <WebLink
                      back={back}
                      href="https://m-film.netlify.app/"
                      target="_blank"
                    >
                      &nbsp;&nbsp;&nbsp;MFilm.com
                    </WebLink>
                  </DeployLink>
                </TitleAndLink>
                <IconLink m="m">
                  <GitIconLink
                    href="https://github.com/Mariwan-A-MOH/MFilm-FULL-STACK-WEB-APP"
                    target="_blank"
                    back={back}
                  >
                    <GitHubIcon className="iicon" />
                  </GitIconLink>
                </IconLink>
              </DESC>
            </Item>
          </LefttCon>
          <RightCon>
            <Item back={back}>
              <ImgCon>
                <ItemImg src={Admin} />
              </ImgCon>
              <DESC back={back}>
                <TitleAndLink m="a">
                  <TitleLink back={back}>ADIMN DASHBORD</TitleLink>
                  <DeployLink>
                    <WebLink back={back}>React.js</WebLink>
                  </DeployLink>
                </TitleAndLink>
                <IconLink>
                  <GitIconLink
                    href="https://github.com/Mariwan-A-MOH/ADMIN-DASHBOARD-React.js-App-"
                    target="_blank"
                    back={back}
                  >
                    <GitHubIcon className="iicon" />
                  </GitIconLink>
                </IconLink>
              </DESC>
            </Item>
          </RightCon>
        </BottomCon>
      </Wrap>
      <Back src={back == "sun" ? backimg : bb} />
    </Container>
  );
};
export default Projects;

const Container = styled.div`
  overflow: hidden;

  width: 100%;
  height: 90vh;
  margin: 100px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  // background: #f9fdff;
  position: relative;
  ${Mobile({ margin: "20px 0px", height: "140vh" })}
  ${Landscape({ margin: "100px 0px", height: "140vh", width: "100%" })}
`;
const Back = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  width: 100%;
  height: 170%;
  // object-fit:cover;
  display: flex;
  justify-content: center;
  align-items: center;
  ${Mobile({ width: "130%" })}
  ${Landscape({ height: "130%" })}
`;
const Wrap = styled.div`
  z-index: 2;

  width: 66%;
  // width: 56%;
  height: 95%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  ${Mobile({ width: "97%", gap: 0 })}
  ${Landscape({ height: "95%", width: "65%", gap: 0, padding: "00px" })}
`;
const Title = styled.h1`
  color: ${(props) =>
    props.back === "sun" ? "#929292" : " rgba(228, 236, 240, 0.7)"};
  height: 3%;
  ${Mobile({ height: "4%", fontSize: 18, fontWeight: 600 })}
  ${Landscape({
    height: "3%",
    fontSize: 28,
    margin: 15,
    fontWeight: 600,
  })}
`;
const TopCon = styled.div`
  width: 100%;
  min-height: 40%;
  // flex: 1;
  // border-right: 2px solid #45e00e;
  padding: 30px 30px 0px 30px;
  ${Mobile({ minHeight: "25%", padding: "10px 10px 0px 10px" })}
  ${Landscape({
    minHeight: "25%",

    width: "100%",
  })}
`;

const Item = styled.div`
  background: ${(props) =>
    props.back === "sun" ? "rgba(244, 251, 255, 0.4)" : "rgba(26, 32, 39,0.5)"};
  width: 100%;
  height: 100%;
  border-radius: 10px;
  // background: WHITE;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  // border: 2px solid gray;
  padding: 8px;
  border: 2px solid rgba(143, 166, 168, 0.1);
  ${Mobile({
    padding: 4,

    border: "1px solid rgba(143, 166, 168, 0.1)",
  })}
  box-shadow:${(props) =>
    props.back === "sun" && "0px 5px 9px 0px rgba(143, 166, 168, 0.2)"};
`;
const ImgCon = styled.div`
  height: 100%;
  border-radius: 10px 10px 0px 0px;
  width: 100%;

  overflow: hidden;
  flex: 4.5;
`;
const ItemImg = styled.img`
  min-height: 100%;
  width: 100%;
  object-fit: cover;
`;
const DESC = styled.div`
  border-radius: 0px 0px 10px 10px;
  flex: 1.2;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  background: ${(props) =>
    props.back === "sun"
      ? "rgba(176, 203, 205, 0.15)"
      : "rgba(26, 32, 39,0.8)"};

  gap: 30px;
  ${Mobile({ flexDirection: "column", gap: 6, paddingBottom: "6px" })}
`;
const TitleAndLink = styled.div`
  flex: ${(props) => (props.m === "m" ? 3.5 : 9)};
  flex: ${(props) => (props.m === "a" ? 2 : 9)};
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-start;
  padding: 8px 20px 0px 20px;
  ${Mobile({ flex: 1 })}
`;
const TitleLink = styled.h2`
  color: ${(props) =>
    props.back === "sun"
      ? "rgba(12, 12, 28, 0.7)"
      : " rgba(228, 236, 240, 0.9)"};
  flex: 1.7;

  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  ${Mobile({ flex: 1.2, fontSize: 14, fontWeight: 900 })}
`;
const DeployLink = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 1;

  width: 100%;
  ${Mobile({ justifyContent: "center" })}
`;
const VCon = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .Visit {
    margin: 0px 5px 5px 5px;

    color: ${(props) =>
      props.back === "sun"
        ? "rgba(69, 69, 69, 0.5)"
        : " rgba(228, 236, 240, 0.7)"};

    ${Mobile({ fontSize: 16, fontWeight: 500 })}
  }
`;
const Vist = styled.p`
  font-size: 18px;
  font-weight: 550;

  color: ${(props) =>
    props.back === "sun"
      ? "rgba(69, 69, 69, 0.8)"
      : " rgba(228, 236, 240, 0.8)"};
  ${Mobile({ fontSize: 14, fontWeight: 500 })}
`;
const WebLink = styled.a`
  font-size: 16px;
  font-weight: 500;

  color: ${(props) =>
    props.back === "sun"
      ? "rgba(69, 69, 69, 0.8)"
      : " rgba(228, 236, 240, 0.8)"};
  transition: all 0.4s;
  &:hover {
    color: ${(props) =>
      props.back === "sun"
        ? "rgba(69, 69, 69, 0.9)"
        : " rgba(228, 236, 240, 0.9)"};
  }
  ${Mobile({ fontSize: 14, fontWeight: 500 })}
`;
const IconLink = styled.div`
  flex: ${(props) => (props.m === "m" ? 1.8 : 1)};
  height: 100%;
  // background: red;
  display: flex;
  justify-content: center;
  align-items: center;

  ${Mobile({ flex: 1, width: "75%", margin: 1 })}
`;
const GitIconLink = styled.a`
  width: 60%;
  height: 80%;

  background: ${(props) =>
    props.back === "sun" ? "rgba(244, 251, 255, 0.7)" : "rgba(26, 32, 39,0.8)"};

  // background: rgba(12, 12, 28,0.9);
  // font-size: 50px;
  text-decoration: none;
  display: flex;
  border-radius: 10px;
  justify-content: center;
  align-items: center;
  transition: all 1s;
  box-shadow:${(props) =>
    props.back === "sun" && "0px 3px 6px 0px rgba(143, 166, 168, 0.05)"};
  ${Mobile({
    width: "100%",
    height: "100%",
    borderRadius: 7,
    padding: "3px",
    border: "1px solid rgba(143, 166, 168, 0.15)",
  })}
  :hover {
    background: ${(props) =>
      props.back === "sun" ? "rgba(244, 251, 255, 0.9)" : "rgb(22, 28, 35)"};
  }
  .iicon {
    font-size: ${(props) => (props.type ? 45 : 35)}px;
    transition: all 1s;

    
  color: ${(props) =>
    props.back === "sun"
      ? " rgba(12, 12, 28, 0.7)"
      : "rgba(244, 251, 255, 0.7)"};
    ${Mobile({ fontSize: 30 })}
    :hover {
 9
      color: ${(props) =>
        props.back === "sun"
          ? " rgba(12, 12, 28, 0.9)"
          : "rgba(244, 251, 255, 0.7)"};
    }
  }
`;

const BottomCon = styled.div`
  width: 100%;
  min-height: 40%;
  padding: 30px;
  // border-right: 2px solid red;
  display: flex;
  gap: 40px;
  justify-content: space-between;
  align-items: center;
  ${Mobile({
    minHeight: "55%",
    padding: "10px 10px 0px 10px",
    flexDirection: "column",
    justifyContent: "center",
  })}
`;
const LefttCon = styled.div`
  flex: 2;
  height: 100%;

  border-radius: 10px;
  ${Mobile({ flex: 1 })}
  ${Landscape({ flex: 1.5 })}
`;
const RightCon = styled.div`
  height: 100%;
  flex: 1.3;
  ${Mobile({ flex: 1 })}

  border-radius: 10px;
`;
